import { Component } from '@angular/core';
import { UserSessionService } from '../../services/user-session.service';

@Component({
  selector: 'app-not-registered',
  templateUrl: './not-registered.component.html',
  styleUrls: ['./not-registered.component.scss'],
  standalone: false,
})
export class NotRegisteredComponent {
  constructor(private userSessionService: UserSessionService) {}

  backToLogin(): void {
    this.userSessionService.logout();
  }
}
